import { Box, Flex, Grid } from 'components/box';
import { Heading, Text } from 'components/typography';
import Step1Icon from 'icons/send-gift-step-1.svg';
import Step2Icon from 'icons/send-gift-step-2.svg';
import Step3Icon from 'icons/send-gift-step-3.svg';
import Step4Icon from 'icons/send-gift-step-4.svg';
import Button from 'components/button';
import { css } from '@emotion/react';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const SendAsGiftModal = ({
  close,
  isOpen,
}: {
  close: () => void;
  isOpen: boolean;
}) => (
  <Modal
    title=" Can I send this as a gift?"
    close={close}
    isOpen={isOpen}
    size="small"
  >
    <Box py={4}>
      <Heading mb={4} fontSize={['m', null, 'l']} textAlign="center">
        Yes, you can. Here&apos;s how.
      </Heading>

      <Grid
        gridTemplateColumns={['100px auto', '140px auto']}
        alignItems="center"
        mx="auto"
        width={['auto', '430px']}
      >
        <Step1Icon
          size={30}
          css={theme => css`
            color: ${theme.colors.darkishGrey};
          `}
        />
        <Text lineHeight={1.5}>
          1. Choose the product you want to send, add it to your cart and
          proceed to checkout.
        </Text>

        <Step2Icon
          size={30}
          css={theme => css`
            color: ${theme.colors.darkishGrey};
          `}
        />
        <Text lineHeight={1.5}>2. Select &quot;Send this as a gift&quot;</Text>

        <Step3Icon
          size={30}
          css={theme => css`
            color: ${theme.colors.darkishGrey};
          `}
        />
        <Text lineHeight={1.5}>
          3. Fill out the recipient&apos;s details and optionally add a
          personalised message.
        </Text>

        <Step4Icon
          size={30}
          css={theme => css`
            color: ${theme.colors.darkishGrey};
          `}
        />
        <Box>
          <Text lineHeight={1.5} mb={2}>
            4. We&apos;ll package your gift and deliver it to their door!
          </Text>
          <Text lineHeight={1.5} fontSize="r" color="darkishGrey">
            We also make sure that only you receive the invoice and receipt of
            payment, for um... obvious reasons.
          </Text>
        </Box>
      </Grid>

      <Flex mt={4} justifyContent="center">
        <Button stretch onClick={close}>
          Got It
        </Button>
      </Flex>
    </Box>
  </Modal>
);

export default SendAsGiftModal;
